import React from "react";
import classNames from "classnames";
import Link from "next/link";

import Logo from "@/components/assets/SimpleLogo";
import LogoSport from "@/components/assets/SimpleLogoSport";
import Apple from "@/icons/social/apple.svg";
import Play from "@/icons/social/play.svg";
import { GridColumns } from "@/components/Container/Container.interface";
import Container from "@/components/Container";
import Typography from "@/components/Typography";
import useRequest from "@/helpers/useRequest";
import { apiPath } from "@/helpers/apiPath";
import { routePath } from "@/helpers/routePath";
import { applicationRoutes } from "@/helpers/applicationRouting";

import styles from "./Footer.module.scss";

export const Footer: React.FC = () => {
  const { data: popularTags } = useRequest(apiPath.POPULAR_TAGS);
  const portal = process.env.NEXT_PUBLIC_PORTAL;
  const isMobileApp = process.env.NEXT_PUBLIC_MOBILE_APP === "true";

  return (
    <footer className={styles.wrapper}>
      <Container className={styles.header}>
        <Typography
          className={styles.heading}
          component="p"
          variant="secondary"
        >
          {portal === "net"
            ? "Interesuj się."
            : "Zmieniamy zasady gry. Każdej."}
        </Typography>
      </Container>

      <Container className={styles.footer} grid={GridColumns.Three}>
        <div className={classNames(styles.box, styles.lined, styles.withLogo)}>
          {portal === "net" ? <Logo /> : <LogoSport />}
        </div>

        {!isMobileApp && (
          <div className={classNames(styles.box, styles.lined)}>
            <Typography variant="h6">Pobierz:</Typography>

            <div className={styles.socials}>
              <a
                className={classNames(styles.socialLink, "footer_appStore")}
                rel="noopener noreferrer"
                target="_blank"
                href={
                  portal === "net"
                    ? "https://apps.apple.com/us/app/newonce-radio/id1364859543"
                    : "https://apps.apple.com/us/app/newonce-sport/id1540556799"
                }
              >
                <Apple />

                <span className={styles.socialLabel}>App Store</span>
              </a>

              <a
                className={classNames(styles.socialLink, "footer_googlePlay")}
                rel="noopener noreferrer"
                target="_blank"
                href={
                  portal === "net"
                    ? "https://play.google.com/store/apps/details?id=com.radioco.m2ed4393b4&hl=pl"
                    : "https://play.google.com/store/apps/details?id=com.newonce.sport&hl=pl"
                }
              >
                <Play />

                <span className={styles.socialLabel}>Google Play</span>
              </a>
            </div>
          </div>
        )}

        <div className={classNames(styles.box)}>
          <Typography className={styles.groupHeading} component="h6">
            Więcej linków od nas
          </Typography>

          <div className={styles.linkBox}>
            <Link
              href={routePath.PAGE.href}
              as={applicationRoutes.FEED + "reklama"}
            >
              <a className={styles.footerLink}>Reklama</a>
            </Link>

            <a
              href="https://praca.newonce.net/"
              className={styles.footerLink}
              target="_blank"
              rel="noreferrer"
            >
              Praca
            </a>

            <Link
              href={routePath.PAGE.href}
              as={applicationRoutes.FEED + "polityka-prywatnosci"}
            >
              <a className={styles.footerLink}>Polityka prywatności</a>
            </Link>

            <Link
              href={routePath.PAGE.href}
              as={applicationRoutes.FEED + "faq"}
            >
              <a className={styles.footerLink}>FAQ</a>
            </Link>

            <a
              href="https://newonce.store"
              className={styles.footerLink}
              target="_blank"
              rel="noreferrer"
            >
              newonce.store
            </a>
          </div>
        </div>

        <div className={classNames(styles.box)}>
          <Typography className={styles.groupHeading} component="h6">
            Aktualnie popularne na newonce
          </Typography>

          {!!popularTags?.length && (
            <div className={styles.linkBox}>
              {popularTags.map((tag) => (
                <Link
                  href={routePath.TAG.href}
                  as={applicationRoutes.TAG + tag.slug}
                  key={tag.slug}
                >
                  <a className={styles.footerLink}>{tag.title}</a>
                </Link>
              ))}
            </div>
          )}
        </div>

        <div className={styles.copyright}>
          © {new Date().getFullYear()}{" "}
          {portal === "net" ? "newonce" : "newonce.sport"}
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
